import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const RedLightSpeedDetXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},};

    // const counts = props.vehCounts
    const asset = props.asset && props.asset.replace('&','and')
    const vehicleClassTbl = props.vehicleClassTbl
    const RLDstat = props.RLDstat
    const RLDdet = props.RLDdet

    const dataVehClass = [];
    const dataDetZone = [];
    const dataDetZoneD = [];

    const headVehClass = [
        [
            {value: "Vehicle type", style: headerStyle},
            {value: "Count", style: headerStyle},
        ],
    ]

    const headDetZone = [
        [
            {value: "Time", style: headerStyle},
            {value: "Dilemma Vehicle", style: headerStyle},
            {value: "Red Light Veh", style: headerStyle},
            {value: "Max Speed", style: headerStyle},
            {value: "Max Speed Dilemma", style: headerStyle},
        ]
    ]

    const headDetZoneD = [
        [
            {value: "Time", style: headerStyle},
            {value: "Class", style: headerStyle},
            {value: "Distance", style: headerStyle},
            {value: "Speed", style: headerStyle},
        ]
    ]

    // vehicle class data
    if (vehicleClassTbl.length>0) {
        dataVehClass.push(
            ['Motorbike', vehicleClassTbl[2]],
            ['Car', vehicleClassTbl[3]],
            ['Van', vehicleClassTbl[4]],
            ['Short Truck', vehicleClassTbl[5]],
        )
        if (vehicleClassTbl[6]>0)
            dataVehClass.push(['Med Truck', vehicleClassTbl[6]])

        dataVehClass.push(['Long Truck', vehicleClassTbl[7]])

        if (vehicleClassTbl[8]>0)
            dataVehClass.push(['Bus', vehicleClassTbl[8]])
        
        dataVehClass.push(['Undefined', vehicleClassTbl[9]])
    }       

        for (let i = 0; i < RLDstat.length; i++) {
            dataDetZone.push([
                RLDstat[i].time,
                RLDstat[i].dilemma_veh,
                RLDstat[i].red_light_veh,
                RLDstat[i].max_speed,
                RLDstat[i].max_speed_dilemma,

            ])
        }

        for (let i = 0; i < RLDdet.length; i++) {
            dataDetZoneD.push([
                RLDdet[i].time_ss,
                RLDdet[i].class,
                RLDdet[i].distance,
                RLDdet[i].speed,

            ])
        }

    let dateFrom = ""
    if (props.dateFrom){
        const d = new Date(props.dateFrom);
        dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
    }

    const dt = "Date " + dateFrom 

    const dataSet = [
        {   columns: [asset, dt],
            data: [ 
            [{value:"Detection Zone", style: headerStyle2}],...headDetZone, ...dataDetZone,"",
            [{value:"Detection Zone Details", style: headerStyle2}],...headDetZoneD, ...dataDetZoneD,"",
            [{value:"Vehicle Classification", style: headerStyle2}],...headVehClass,...dataVehClass, "",
                ],
        },
    ]

        return (
            <div>
                <ExcelFile filename={asset} element={<Button size="sm" variant="light"><FaDownload />&nbsp; Download </Button>}>
					<ExcelSheet dataSet={dataSet} name={asset} />
				</ExcelFile>
            </div>
        );
}


export default RedLightSpeedDetXls;


